import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useGetAssetOperationData = () => {
  const fetchAssetOperationData = async () => {
    const response = await fetch(
      `${WiMuleSQL}/api/WiTool/GetAssetOperationalData`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // if there are no backlogged orders
    if (response.status === 204) {
      // Return a specific value or flag indicating no content
      return { noContent: true };
    }

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getAssetOperationData"],
    queryFn: fetchAssetOperationData,
    enabled: true,
    // Setting the stale time to 1 hour (3600000 milliseconds)
    staleTime: 3600000,
  });

  return { data, isLoading, isError, error };
};
